// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"642":"fd3d1968","651":"20c00bd1","722":"89302b11","981":"d1b8b7ff"}[chunkId] + ".chunk.js";
};